
            const data = {"name":"close-1","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"m442 100-30-30-156 156L100 70l-30 30 156 156L70 412l30 30 156-156 156 156 30-30-156-156z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    